import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const NotFound = ({ homePath = "/dashboard" }) => {
  const { t } = useTranslation("common");

  return (
    <div className="min-vh-100 d-flex align-items-center justify-content-center position-relative overflow-hidden" style={{ background: "linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%)" }}>
      {/* Decorative background elements */}
      <div className="position-absolute rounded-circle" style={{ width: "400px", height: "400px", background: "linear-gradient(45deg, #667eea 0%, #764ba2 100%)", top: "-100px", left: "-100px", opacity: "0.15", filter: "blur(50px)" }}></div>
      <div className="position-absolute rounded-circle" style={{ width: "600px", height: "600px", background: "linear-gradient(45deg, #43e97b 0%, #38f9d7 100%)", bottom: "-200px", right: "-200px", opacity: "0.15", filter: "blur(60px)" }}></div>
      
      <div className="container position-relative z-1">
        <div className="row justify-content-center">
          <div className="col-12 col-md-8 col-lg-6">
            <div className="card border-0 shadow-lg" style={{ background: "rgba(255, 255, 255, 0.75)", backdropFilter: "blur(20px)", WebkitBackdropFilter: "blur(20px)", borderRadius: "24px" }}>
              <div className="card-body p-5 text-center">
                <div className="mb-4 position-relative d-inline-block">
                  <div className="position-absolute top-50 start-50 translate-middle w-100 h-100 bg-primary opacity-25 rounded-circle" style={{ filter: "blur(25px)", transform: "scale(1.5)" }}></div>
                  <i className="fas fa-ghost text-primary position-relative z-1" style={{ fontSize: '5rem', animation: 'float 3s ease-in-out infinite' }}></i>
                </div>
                
                <h1 className="display-1 fw-bolder mb-2" style={{ background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)", WebkitBackgroundClip: "text", WebkitTextFillColor: "transparent" }}>
                  {t("notFound.title", "404")}
                </h1>
                
                <h2 className="h3 fw-bold text-dark mb-3">
                  {t("notFound.subtitle", "Page Not Found")}
                </h2>
                
                <p className="text-muted mb-5 fs-5">
                  {t("notFound.message", "The page you're looking for doesn't exist or has been moved.")}
                </p>
                
                <Link to={homePath} className="btn btn-primary btn-lg rounded-pill px-5 py-3 shadow-sm text-uppercase fw-bold" style={{ transition: "all 0.3s ease" }}>
                  <i className="fas fa-home me-2"></i>
                  {t("notFound.backHome", "Go to Dashboard")}
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
      
      <style>{`
        @keyframes float {
          0% { transform: translateY(0px) rotate(0deg); }
          50% { transform: translateY(-15px) rotate(5deg); }
          100% { transform: translateY(0px) rotate(0deg); }
        }
        .btn-primary:hover {
          transform: translateY(-3px);
          box-shadow: 0 10px 20px rgba(0,0,0,0.1) !important;
        }
      `}</style>
    </div>
  );
};

export default NotFound;